import React from 'react'

import { EmailIcon, FbIcon, InstagramIcon } from '../../Countdown/Icons'
import './SocialButtons.scss'

const SocialButtons = () => {
  return (
    <div className="socialButtons">
      <FbIcon href="https://www.facebook.com/time.suburbs" />
      <EmailIcon href="mailto: time.suburbs@gmail.com" />
      <InstagramIcon href="https://www.instagram.com/timesuburbs/" />
    </div>
  )
}

export default SocialButtons
